import { render, staticRenderFns } from "./m_notice.vue?vue&type=template&id=214c09db&scoped=true&"
import script from "./m_notice.vue?vue&type=script&lang=js&"
export * from "./m_notice.vue?vue&type=script&lang=js&"
import style0 from "./m_notice.vue?vue&type=style&index=0&id=214c09db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c09db",
  null
  
)

export default component.exports